import { render, staticRenderFns } from "./FooterMainMenu.vue?vue&type=template&id=5259faf1"
import script from "./FooterMainMenu.vue?vue&type=script&lang=js"
export * from "./FooterMainMenu.vue?vue&type=script&lang=js"
import style0 from "./FooterMainMenu.vue?vue&type=style&index=0&id=5259faf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports